// src/pages/OrderHeadReport.js
import { auth } from "../firebase";


import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Layout from "../components/Layout";
import {
  collection,
  getDocs,
  getDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import * as XLSX from "xlsx";

import { onAuthStateChanged } from "firebase/auth";



const sendWhatsApp = (phone, message) => {
  if (!phone) {
    alert("Party phone number not available");
    return;
  }

  let cleanPhone = phone.replace(/\D/g, "");
  if (cleanPhone.length === 10) cleanPhone = "91" + cleanPhone;

  const url = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};



function OrderHeadReport() {

const utilityBtn = {
  padding: "6px 12px",
  fontSize: "13px",
  fontWeight: 500,
  borderRadius: "6px",
  background: "#0d6efd",
  color: "#fff",
  border: "1px solid #0d6efd",
  cursor: "pointer",
};

const formatApprovedDate = (order) => {
  if (order?.approvedAt?.toDate) {
    return order.approvedAt.toDate().toLocaleDateString("en-IN");
  }
  if (order?.approvedDateOnly) {
    return new Date(order.approvedDateOnly).toLocaleDateString("en-IN");
  }
  return "-";
};

const buildWaMessage = (order) => `

Order Approved ✅




Order No: ${order.displayOrderId}
Party: ${order.partyName || ""}

Order Date: ${formatApprovedDate(order)}


Delivery Challan:
${order.challanPdfUrl || "Not available"}

– QuickBill
`.trim();


  const today = new Date().toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const [rows, setRows] = useState([]);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  // Auto-load company info
  useEffect(() => {
    const loadCompany = async () => {
      const ref = doc(db, "companyInfo", "default");
      const snap = await getDoc(ref);
      if (snap.exists()) setCompany(snap.data());
    };
    loadCompany();
  }, []);

  // Auto-load today's report
  useEffect(() => {
  loadReport();
}, [fromDate, toDate]);

  // ------------------------
  // Load report
  // ------------------------
  const loadReport = async () => {
    try {
      setLoading(true);
      const q = query(collection(db, "orders"), 
	  
	  where("status", "==", "APPROVED"));
      const snap = await getDocs(q);

      let list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

      const parse = (s) => (s ? new Date(s + "T00:00:00") : null);
      const from = parse(fromDate);
      const to = parse(toDate);

      list = list.filter((o) => {
        if (!o.approvedAt?.toDate) return false;
const d = o.approvedAt.toDate();

        if (from && d < from) return false;
        if (to) {
          const end = new Date(to);
          end.setHours(23, 59, 59);
          if (d > end) return false;
        }
        return true;
      });

      list.sort((a, b) => new Date(b.approvedAt) - new Date(a.approvedAt));

      setRows(list);
    } catch (e) {
      console.error(e);
      alert("Error loading report");
    } finally {
      setLoading(false);
    }
  };

  // ------------------------
  // E-WAY BILL JSON BUILDER
  // ------------------------
  const generateEwayJson = (order) => {
    if (!company || !order) {
      alert("Missing company/order data");
      return;
    }

    const json = {
      supplyType: "O",
      subSupplyType: "10",
      docType: "CHL",
      docNo: order.displayOrderId || order.finalOrderId,
      docDate: order.orderDate
        ? new Date(order.orderDate).toLocaleDateString("en-IN")
        : "",

      fromGstin: company.gstin || "",
      fromTrdName: company.name || "",
      fromAddr1: company.address1 || "",
      fromAddr2: company.address2 || "",
      fromStateCode: "29",
      fromPlace: company.city || "",
      fromPincode: company.pincode || "",

      toGstin: "URP",
      toTrdName: order.partyName || "",
      toAddr1: order.address || "",
      toAddr2: "",
      toStateCode: "29",
      toPlace: "Bangalore",
      toPincode: "560001",

      totalValue: order.totalBasic || 0,
      cgstValue: (order.totalGST || 0) / 2,
      sgstValue: (order.totalGST || 0) / 2,
      cessValue: order.totalCESS || 0,
      otherValue: order.totalAddlCess || 0,
      totalInvoiceValue: order.totalAmount || 0,

      transMode: "1",
      vehicleNo: order.vehicleNo || "-",
      vehicleType: "R",
      transDistance: "1",
    };

    const blob = new Blob([JSON.stringify(json, null, 2)], {
      type: "application/json",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `EWB-${order.displayOrderId || order.finalOrderId}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // ------------------------
  // XLSX EXPORT
  // ------------------------
  const exportXLSX = () => {
    if (filteredRows.length === 0) {
      alert("No data to export!");
      return;
    }

    const excelData = filteredRows.map((r) => {
  const orderDisplayId =
    r.displayOrderId || r.finalOrderId || r.tempOrderId || r.id;

  return {
    "Order ID": orderDisplayId,
    "Party Name": r.partyName,

    // 🔹 Order Date = createdAt (DISPLAY ONLY)
    "Order Date": r.createdAt?.toDate
      ? r.createdAt.toDate().toLocaleDateString("en-IN")
      : "-",

    // 🔹 Approved At = FINAL SOURCE OF TRUTH
    "Approved At": r.approvedAt?.toDate
      ? r.approvedAt.toDate().toLocaleString("en-IN")
      : "-",

    "Total Qty": r.totalQty,
    "Total Amount": Number(r.totalAmount || 0).toFixed(2),
  };
});


    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "OrderHeadReport");

    XLSX.writeFile(wb, "OrderHeadReport.xlsx");
  };

  // ------------------------
  // Search filter
  // ------------------------
  const filteredRows = rows.filter((r) => {
    const s = search.toLowerCase();

    return (
      r.id.toLowerCase().includes(s) ||
      (r.partyName || "").toLowerCase().includes(s) ||
      String(r.totalAmount || "").includes(s)
    );
  });

  return (
    <Layout>
  <div style={{ padding: 20, marginLeft: "1px", width: "calc(100% - 100px)", overflowX: "auto" }}>
        <h2>Order Head Report</h2>

        {/* Filters */}
        <div style={{ display: "flex", gap: 10, marginBottom: 15 }}>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />

          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />

          <button onClick={loadReport} disabled={loading}>
            {loading ? "Loading..." : "Load"}
          </button>








          <button
            onClick={exportXLSX}
            style={{
              padding: "8px 14px",
              background: "green",
              color: "white",
              borderRadius: 6,
              border: "none",
            }}
          >
            Export XLSX
          </button>

          <input
            type="text"
            placeholder="Search Party / Order ID / Amount..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              flex: 1,
              padding: 8,
              borderRadius: 6,
              border: "1px solid #ccc",
            }}
          />
        </div>

        {/* TABLE */}
        {filteredRows.length === 0 ? (
          <p>No data found.</p>
        ) : (
          <table
            border="1"
            cellPadding="8"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "1200px",
            }}
          >
            <thead style={{ background: "#f5f5f5", position: "sticky", top: 0 }}>
              <tr>
                <th>Order ID</th>
                <th>Party</th>
                <th>Created At</th>
                <th>Approved At</th>
                <th>Total Qty</th>
                <th>Total Amount</th>
				<th>Vehicle No</th>
                <th>Challan</th>
                <th>Trip Sheet</th>
                <th>E-Way Bill</th>
				<th>WhatsApp</th>
              </tr>
            </thead>

            <tbody>
              {filteredRows.map((r, i) => {
                const total = Number(r.totalAmount || 0).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                });

                return (
                  <tr
                    key={r.id}
                    style={{ background: i % 2 === 0 ? "#ffffff" : "#fafafa" }}
                  >
                    <td>{r.displayOrderId}</td>
                    <td>{r.partyName}</td>
                    <td>{r.createdAt?.toDate? r.createdAt.toDate().toLocaleDateString("en-IN"): "-"}</td>
                    <td>{r.approvedAt?.toDate? r.approvedAt.toDate().toLocaleString("en-IN"): "-"}</td>

                    <td>{r.totalQty}</td>
                    <td style={{ textAlign: "right" }}>{total}</td>
					
					
					<td style={{ textAlign: "center" }}>{r.vehicleNo || "-"}</td>

                    


                    {/* NEW EWAY BILL DOWNLOAD BUTTON */}
                    
					
{/* CHALLAN PDF */}
<td style={{ textAlign: "center" }}>
  {r.challanPdfUrl ? (
    <button
      onClick={() => window.open(r.challanPdfUrl, "_blank")}
      style={{
        padding: "6px 12px",
        borderRadius: 6,
        background: "#b300b3",
        color: "#fff",
        border: "none",
        cursor: "pointer",
      }}
    >
      Download
    </button>
  ) : (
    "-"
  )}
</td>

{/* TRIP SHEET PDF */}
<td style={{ textAlign: "center" }}>
  {r.tripSheetPdfUrl ? (
    <button
      onClick={() => window.open(r.tripSheetPdfUrl, "_blank")}
      style={{
        padding: "6px 12px",
        borderRadius: 6,
        background: "#198754",
        color: "#fff",
        border: "none",
        cursor: "pointer",
      }}
    >
      Download
    </button>
  ) : (
    "-"
  )}
</td>

{/* E-WAY BILL */}
<td style={{ textAlign: "center" }}>
  <button
    onClick={() => generateEwayJson(r)}
    style={{
      padding: "6px 12px",
      borderRadius: 6,
      background: "#0d6efd",
      color: "#fff",
      border: "none",
      cursor: "pointer",
    }}
  >
    Download
  </button>
</td>

{/* WHATSAPP */}
<td style={{ textAlign: "center" }}>
  <button
    onClick={() => sendWhatsApp(r.partyPhone, buildWaMessage(r))}
    disabled={!r.partyPhone}
    style={{
      padding: "6px 10px",
      background: r.partyPhone ? "#25D366" : "#ccc",
      color: "#fff",
      border: "none",
      borderRadius: 6,
      cursor: r.partyPhone ? "pointer" : "not-allowed",
      fontSize: "13px",
    }}
  >
    📲 WhatsApp
  </button>
</td>
					
					
					


					
					
					
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      
 </div>
  </Layout>
  );
}

export default OrderHeadReport;
